
export const CURRENT_ID = "current_id";